import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";

import infoIcon from "../../assets/icons/infoIcon.svg";
import { logout } from "../../redux/slices/authSlice";
import Swal from "sweetalert2";

//import SearchIcon from "../../assets/icons/search.svg";
import NotificationIcon from "../../assets/icons/notification.svg";
//import ProfileIcon from "../../assets/icons/sidebar/profileActive.svg";
import Caret from "../../assets/icons/dropIcon.svg";
import closeIcon from "../../assets/icons/closeIcon.svg";
import { MdPerson } from "react-icons/md";
import {
  HeaderComponents,
  HeaderContainer,
  HeaderIcons,
  HeaderTitle,
  NavigationContainer,
  MenuHeader,
  // Searchbar,
} from "./Headerstyle";

import {
  getNotification,
  getNotificationCount,
  deleteAllNotifications,
} from "../../redux/slices/notificationSlice";

// const notifications = [
//   { id: 1, title: "Advertiser Account not registered", message: "Your account is not registered." },
//   { id: 2, title: "New message from support", message: "You have a new message from support." },
//   { id: 3, title: "Profile Update", message: "Your profile has been updated successfully." },
// ];

const Header = ({ title, forwardRef }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  //const [notificationCount, setNotificationCount] = useState(25);
  const { notifications, count } = useSelector((state) => state.notification);
  //console.log(count.count)

  useEffect(() => {
    dispatch(getNotificationCount());
    // const notificationsCount = notifications.filter((notify) => notify.isRead === false).length;
    // setNotificationCount(notificationsCount);
  }, [dispatch]);

  const handleNotification = () => {
    dispatch(getNotification());
  };
  const handleDeleteNotification = () => {
    dispatch(deleteAllNotifications());
    handleNotification();
    dispatch(getNotificationCount());
  };

  const [showMenu, setShowMenu] = useState(false);

  const openNav = () => {
    setShowMenu(true);
    handleNotification();
  };

  const closeNav = () => {
    setShowMenu(false);
  };

  const handleLogout = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "You will be logged out!",
      icon: null,
      iconHtml: `<img src=${infoIcon} alt="error" style="width:50px;">`,
      showCancelButton: true,
      confirmButtonColor: "#03a9f4",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, logout!",
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(logout());
        navigate("/login");
      }
    });
  };
  return (
    <HeaderContainer>
      <HeaderTitle>
        <div className="hamburger-icon" ref={forwardRef}>
          &#9776;
        </div>
      </HeaderTitle>

      <HeaderComponents>
        <HeaderIcons>
          <div>
            {/* <img src={SearchIcon} alt="Search" /> */}
          </div>
          <div
            onClick={showMenu ? closeNav : openNav}
            style={{ cursor: "pointer", position: "relative" }}
          >
            <img src={NotificationIcon} alt="Notification" />
            {count?.count > 0 && (
              <span className="notification-badge">{count?.count}</span>
            )}
          </div>
          {showMenu && (
            <NavigationContainer className="menu">
              <MenuHeader>
                <h3>Notifications</h3>
                <span className="close-menu" onClick={closeNav}>
                  <img src={closeIcon} alt="Logo" />
                </span>
              </MenuHeader>
              <div className="clear">
                <p>{/* All Notifications ({notifications?.length}) */}</p>
                {notifications.length > 0 && (
                  <span onClick={handleDeleteNotification}>Clear all</span>
                )}
              </div>
              {notifications?.length > 0 ? (
                notifications.map((notification) => (
                  <div className="wrapper" key={notification.id}>
                    <h4>{notification.title}</h4>
                    <p>{notification.content}</p>
                  </div>
                ))
              ) : (
                <div >
                  <p style={{ marginTop: '150px', textAlign: 'center' }}>No notifications are currently available.</p>
                </div>
              )}
            </NavigationContainer>
          )}

          <div className="nav-item">
            <div className="dropBtn">
            <MdPerson className="circled" />
              <div>
                <img className="caret" src={Caret} alt="caret" />
              </div>
            </div>
            <div className="dropdown-content">
              <Link to="/profile">Profile</Link>
              <Link onClick={handleLogout}>Logout</Link>
            </div>
          </div>
        </HeaderIcons>
      </HeaderComponents>
    </HeaderContainer>
  );
};

export default Header;
